import * as IF from "infrontjs";
import { IndexState } from "../state/IndexState.js";

export class StateManager extends IF.StateManager
{
    constructor( appInstance )
    {
        super( appInstance);
    }

    async switchTo( newState )
    {
        if ( this.currentState && this.currentState.getId() === IndexState.ID )
        {
            this.currentState.switchInnerState( this.app.router.currentRoute );
        }
        else
        {
            super.switchTo( newState );
        }
    }
}
